<!--
 * @Author: 麦勇潮
 * @Date: 2020-12-21 16:14:32
 * @LastEditors: 麦勇潮
 * @LastEditTime: 2021-02-01 19:55:25
 * 该文件只是ios壳包，webviwe加载链接时，调用支付组件
-->
<template>
  <div id="recharge-box">
    <div id="recharge-box-mj">
      <a href="javascript:;" class="close" id="recharge-close" @click="closeRecharge()"></a>
      <iframe :src="src" id="pay-container"></iframe>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import configUrl from '../utility/config.js'
import FN from '../utility/fn.js'
import FUSE from '../fuse/fuse.sdk'
import { requestEncrypt, returnDecrypt } from '@/utility/fuse.auth'
import { thirdReport, adReport } from '../utility/thirdSdk.js';
export default {
  data() {
    return {
      src: '',
      pay_list: '',
      payParam: {},
      recharge: FN.isWX ? 0 : 1
    }
  },
  computed: {
    ...mapGetters(['rechargeAges'])
  },
  destroyed() {
    window.removeEventListener('message', this.MessageListerner)
  },
  mounted() {
    // console.log('enter--------------------------', this.rechargeAges)
    window.addEventListener(
      'message',
      this.MessageListerner,
      false
    )
    this.rechargeList(this.rechargeAges)
    // 监听支付页面回调关闭函数,关闭支付页面
    document.getElementById("pay-container").onload = () => {
      let data = FUSE.getData()
      let payParam = this.payParam
      document.getElementById('pay-container').contentWindow.postMessage({ type: 'getUserInfo', data }, '*')
      document.getElementById('pay-container').contentWindow.postMessage({ type: 'getPInfo', data: payParam }, '*')
    }
  },
  methods: {
    MessageListerner(event) {
      let data = event.data
      if (data.type === 'pay' && data.data === 'close') {
        this.closeRecharge()
      } else if (data.data === 'closeDaley') {
        setTimeout(() => {
          this.closeRecharge()
        }, 2000);
      }
    },
    App_alipay(url) {
      this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
      setTimeout(function () {
        if (typeof mjWebview === 'object') {
          // 如果在大千渠道安卓内打壳
          mjWebview.clickZfb('http:' + configUrl.__gamepayDomain.get() + url)
        } else if (FN.isIOS) {
          // ios系统下支付
          try {
            // 如果在大千渠道IOS内打壳
            // 因为ios的PostMessage长度限制,所以就分两节
            let isoUrl = 'http:' + configUrl.__gamepayDomain.get() + url
            let url1 = isoUrl.substr(0, 800)
            let url2 = isoUrl.substr(800)
            window.webkit.messageHandlers.webViewApp.postMessage(url1) // ios壳子支付
            window.webkit.messageHandlers.webViewApp2.postMessage(url2) // ios壳子支付
          } catch (err) {
            window.location.href = 'http:' + configUrl.__gamepayDomain.get() + url //  web跳转支付
          }
        } else {
          window.location.href = 'http:' + configUrl.__gamepayDomain.get() + url //  web跳转支付
        }
      }, 500)
    },
    App_wxpay(url) {
      this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
      setTimeout(function () {
        if (typeof mjWebview === 'object') {
          mjWebview.clickWx('http:' + configUrl.__gamepayDomain.get() + url)
        } else if (FN.isIOS) {
          try {
            // 因为ios的PostMessage长度限制,所以就分两节
            let isoUrl = 'http:' + configUrl.__gamepayDomain.get() + url
            let url1 = isoUrl.substr(0, 800)
            let url2 = isoUrl.substr(800)
            window.webkit.messageHandlers.webViewApp.postMessage(url1) // ios壳子支付
            window.webkit.messageHandlers.webViewApp2.postMessage(url2) // ios壳子支付
          } catch (err) {
            // window.location.href = 'http:' + configUrl.__gamepayDomain.get() + url //  web跳转支付
            window.location.href = url //  web跳转支付
          }
        } else {
          // window.location.href = 'http:' + configUrl.__gamepayDomain.get() + url //  web跳转支付
          window.location.href = url //  web跳转支付
        }
      }, 500)
    },
    rechargeList(data) {
      // cp点击购买,触发请求得到支付的链接
      let _this = this
      let VERSION = '1.0'
      let uuid = FN.getURLparams().openid ? md5(FN.getURLparams().openid) : FN.getURLparams().utma ? FN.getURLparams().utma : FN.getLocal('equipment')
      let { amount, roleId, roleName, serverId, serverName, order_id, product_id, cut_pay } = data
      let { name, old_id } = FN.getSession('USER_INFO')
      let KEY = String(new Date().getTime()).substr(0, 10)
      // 获取package_id 和 game_id
      let { package_id, game_id } = FN.getLocal('h5sdk')
      let globalHeader = {}
      let extFooter = {}
      // 全局头部信息
      globalHeader = {
        package_id, // 必填    包ID
        game_id, // 必填    游戏id
        is_jsdk: 1 // 必填  是否JSDK，1:是， 0：否
      }
      // 全局拓展信息
      extFooter = {
        imei: FN.getLocal('equipment'), // 手机IMEI/IDFA
        mac: FN.getLocal('equipment'), // 手机mac网卡地址
        device: uuid, // 设备标识（每次游戏安装之后生成并存储到本地; MD5(IMEI/IDFA+机型+MAC+分辨率)）
        screen: window.screen.width + 'x' + window.screen.height, // 分辨率
        platform: FN.isMobile ? (FN.isIOS ? 1 : FN.isAndroid ? 2 : 3) : 3, // 手机系统: 1、ios；2、android；3、其他
        model: '', // 手机机型
        cookie_uuid: uuid, // 唯一标识码，客户端生成一个唯一标识存到cookie
        system: '', // 手机系统版本
        system_language: '', // 手机语言
        net: 4, // 手机网络1、2G；2、3G；3、wifi；4、其他
        operator: '', // 运营商; 客户端传递运营商首字母简写大写
        location: '', // 地址位置
        version: VERSION // 必填SDK版本号
      }
      let newObj = {
        ...globalHeader,
        ...extFooter,
        cookie_uuid: FN.getLocal('h5sdk').cookie_uuid,
        uid: old_id,
        user_name: name, // string必填用户名
        fee: amount, // int必填充值金额单位分
        server_id: serverId, // int 必填 分服编号
        server_name: serverName, // string 分服名称
        role_id: roleId, // string 必填 角色id
        role_name: roleName, // string 必填 角色名称
        callback_info: order_id, // string 必填 回调信息
        notify_url: 'https:' + configUrl.__h5apiDomain.get('jsLoad') + FN.getSession('FUSE_CHANNEL_INFO').channel + '_notify.php', // string 必通知地址
        app_name: FN.getSession('FUSE_CHANNEL_INFO').game_name,
        channel: FN.getSession('FUSE_CHANNEL_INFO').channel,
        h5sdk_url: window.location.href,
        app_store: 1 // 如果是IOS壳包
      }
      this.payParam = newObj
      let p = requestEncrypt(JSON.stringify(newObj), KEY).e
      let pay_url = FN.getSession('SETTING_URLS').zf
        // let pay_url = "http://account.neya.cc/pay"
      // let pay_url = "http://online-account.lcp.com/v1/pay"
      this.src = `${pay_url}?p=${p}&ts=${KEY}&js=1`
    },
    closeRecharge() {
      this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
      setTimeout(() => {
        this.checkOrder()
      }, 3000)
    },
    // 检查支付结果
    checkOrder() {
      window.MJFUSESDK.checkOrderStatus({
        cp_order_id: this.rechargeAges.orderId,
        order_id: this.rechargeAges.order_id
      }).then(res => {
        if (res.code === 0 && Number(res.data.status) === 1) {
          const money = Number((this.rechargeAges.amount/100).toFixed(2))
          const id = this.rechargeAges.fuseParams.cp_product_id
          // 市场数据上报
          adReport('Purchase', {
            currency: 'USD',
            value: money,
            contents: id,
          })
          adReport('StartTrial', {
            currency: 'USD',
            value: money,
            contents: id,
          })
          // 运营数据上报
          window.MJFUSESDK.getBuryingConfig().then(buryingRes => {
            if (buryingRes.code === 0 && buryingRes.data) {
              this.rechargeUpdate(id, money, buryingRes.data.cfg)
            }
          })
        }
      })
    },
    // 第三方充值上报 运营数据上报
    rechargeUpdate(id, money, buryingConfig) {
      // money 单位元
      // console.log('rechargeReport', id, money)
      if (!buryingConfig.rechange) return
      // 旧的累充金额
      const oldRechangeAmount = FN.getSession('buryingConfig').rechange.amount
      // 保存最新的配置
      FN.saveSession('buryingConfig', buryingConfig)
      
      // 判断是否购买指定商品
      if (buryingConfig.rechange.goods_config) {
        const buryingItem = buryingConfig.rechange.goods_config.filter(item => String(item.value) === String(id))[0]
        // console.log('商品id:', buryingItem)
        if (buryingItem) {
          // 触发事件
          thirdReport({
            ...buryingItem,
            REVENUE: money,
            VALUE: money,
            CONTENT_ID: id,
            CURRENCY: 'USD',
          })
        }
      }
      // 判断是否到达累充金额
      if (buryingConfig.rechange.purchase_amount_config) {
        // 已累充金额 转换单位元
        // const rechangeAmount = Number((buryingConfig.rechange.amount / 100).toFixed(2))
        // 判断条件，配置金额 大于 前累充金额， 且配置金额 小于等于 当前累充金额
        const buryingItems = buryingConfig.rechange.purchase_amount_config.filter(item => item.value > oldRechangeAmount && item.value <= buryingConfig.rechange.amount)
        // console.log('累充金额:', buryingItem)
        for (let i = 0; i < buryingItems.length; i++) {
          // 触发事件
          thirdReport({
            ...buryingItems[i],
            REVENUE: money,
            VALUE: money,
            CONTENT_ID: id,
            CURRENCY: 'USD',
          })
        }
      }
      // 判断是否到达累充次数
      if (buryingConfig.rechange.purchase_times_config) {
        const buryingItem = buryingConfig.rechange.purchase_times_config.filter(item => Number(item.value) === Number(buryingConfig.rechange.times))[0]
        // console.log('累充次数:', buryingItem)
        if (buryingItem) {
          // 触发事件
          thirdReport({
            ...buryingItem,
            REVENUE: money,
            VALUE: money,
            CONTENT_ID: id,
            CURRENCY: 'USD',
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#recharge-box {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9;
}

#recharge-box-mj {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  width: 6.4rem;
  height: 80%;
  background: #fff;
  border-radius: 0.25rem;
}

#pay-container {
  position: relative;
  z-index: 100;
  // transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 0.25rem;
  border: none;
  font-size: 1rem;
}

#recharge-box-mj .close {
  position: absolute;
  width: 0.8rem;
  height: 0.8rem;
  margin-top: 0.08rem;
  margin-left: 0.08rem;
  background-image: url(../assets/img/close.png);
  background-size: 0.54rem 0.54rem;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 999;
}
</style>
